import {
  GetTableListParams,
  MeetingPrepEmail,
  MeetingPrepEntity,
  TServerErrorResponse,
} from "@/types";
import { http } from "@/api/httpHandler";
import { links } from "@/constants";

export interface MeetingPrepCreateRequestPayload {
  meetingId?: string;
  // when omitted, the backend generates
  title?: string;
  clientIds: string[];
}
export interface MeetingPrepRegenerateRequestPayload {
  id: string;
  clientIds: string[];
}

export interface MeetingPrepUpdateRequestPayload
  extends Partial<MeetingPrepEntity> {}

export const GET_MEETING_PREP_ALL = "GET_MEETING_PREP_ALL";
export const CREATE_MEETING_PREP = "CREATE_MEETING_PREP";
export const GET_MEETING_PREP = "GET_MEETING_PREP";
export const GET_MEETING_PREP_EMAIL = "GET_MEETING_PREP_EMAIL";

export const getAllMeetingPrep = async (
  params: Partial<GetTableListParams> & {
    includeClients: boolean;
  },
) => {
  try {
    // TODO: change startat and endat on the server side
    const response = await http.get<MeetingPrepEntity[]>(
      links.meetingPrep.index,
      {
        params,
      },
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getMeetingPrep = async (id?: string) => {
  if (!id) {
    return null;
  }
  try {
    const response = await http.get<MeetingPrepEntity>(
      links.meetingPrep.meetingPrepById(id),
      {
        params: {
          includeClients: true,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createMeetingPrep = async (
  data: MeetingPrepCreateRequestPayload,
) => {
  try {
    const response = await http.post<MeetingPrepEntity>(
      links.meetingPrep.index,
      data,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const regenerateMeetingPrep = async (
  meetingPrep: MeetingPrepRegenerateRequestPayload,
) => {
  const { id, ...data } = meetingPrep;
  try {
    const response = await http.put<MeetingPrepEntity>(
      links.meetingPrep.meetingPrepById(id),
      data,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateMeetingPrep = async (
  meetingPrep: MeetingPrepUpdateRequestPayload,
) => {
  if (!meetingPrep.id) {
    throw new Error("Meeting prep id is required");
  }
  try {
    const response = await http.patch<MeetingPrepEntity>(
      links.meetingPrep.meetingPrepById(meetingPrep.id),
      meetingPrep,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const generateMeetingPrepEmail = async ({
  id,
  templateId,
}: {
  id: string;
  templateId?: string;
}) => {
  if (!id) {
    return;
  }
  try {
    const response = await http.put<MeetingPrepEmail>(
      links.meetingPrep.meetingPrepByIdEmail(id),
      templateId ? { templateId } : undefined,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteMeetingPrep = async (id: string) => {
  try {
    const response = await http.delete<MeetingPrepEntity>(
      links.meetingPrep.meetingPrepById(id),
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getMeetingPrepEmail = async (meetingPrepId?: string) => {
  if (!meetingPrepId) {
    return;
  }
  try {
    const response = await http.get<MeetingPrepEmail>(
      links.meetingPrepEmail.meetingPrepEmailByPrepId(meetingPrepId),
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateMeetingPrepEmail = async (
  data: Partial<MeetingPrepEmail>,
) => {
  if (!data?.id) {
    return;
  }
  try {
    const response = await http.put<MeetingPrepEmail>(
      links.meetingPrepEmail.meetingPrepEmailById(data?.id),
      data,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
